import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, NullableEmailSchema, PaginationSchema, UuidSchema } from './common.js';
export const FacturaItemSchema = z.object({
    descripcion: z.string().min(1),
    cantidad: z.number().positive(),
    precioUnitario: DecimalLikeSchema,
    tasaIva: z.union([z.literal(10), z.literal(5), z.literal(0)]).default(10),
});
export const FacturaSchema = z.object({
    id: UuidSchema,
    clienteId: UuidSchema.nullable(),
    clienteNombre: z.string(),
    clienteDoc: z.string(),
    clienteEmail: NullableEmailSchema,
    nroFactura: z.string().nullable(),
    condicionPago: z.string().nullable(),
    moneda: z.string().nullable(),
    total: DecimalLikeSchema,
    ivaTotal: DecimalLikeSchema.nullable(),
    estado: z.string(),
    cdc: z.string().nullable(),
    timbrado: z.string().nullable(),
    qrTexto: z.string().nullable(),
    errorDfe: z.string().nullable().optional(),
    errorKind: z.enum(['rejected', 'unavailable']).nullable().optional(),
    emailSentAt: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateFacturaRequestSchema = z.object({
    clienteId: UuidSchema.nullable().optional(),
    clienteNombre: z.string().min(1),
    clienteDoc: z.string().min(1),
    clienteEmail: z.string().email().nullable().optional(),
    condicionPago: z.string().optional(),
    moneda: z.enum(['PYG', 'USD']).default('PYG'),
    items: z.array(FacturaItemSchema).min(1),
    total: DecimalLikeSchema,
    ivaTotal: DecimalLikeSchema.optional(),
});
export const FacturaListQuerySchema = PaginationSchema.extend({
    estado: z.string().max(40).optional(),
    clienteId: UuidSchema.optional(),
});
export const EnviarFacturaEmailRequestSchema = z.object({
    email: z.string().email().optional(),
});
export const EnviarFacturaEmailResponseSchema = z.object({
    sent: z.boolean(),
    emailSentAt: IsoDateTimeSchema.nullable(),
});
// Onda 2: estado do DE no SIFEN (consultStatus DDE) — codRes/msgRes do SIFEN.
export const EstadoSifenResponseSchema = z.object({
    codRes: z.string(),
    msgRes: z.string(),
    fecProc: z.number().nullable(),
});
//# sourceMappingURL=facturas.js.map